import React, { createContext, useContext } from "react";
import { getMrqData, getMrqs } from "../api";
import { useMcsContext } from "../MCS.context";

const MrqContext = createContext();
export const useMrqContext = () => useContext(MrqContext);

function MrqContextProvider({ children }) {
  const { project, setSelectedMrqData } = useMcsContext();

  const mrqData = project.selectedMrq;

  const [mrqList, setMrqList] = React.useState([]);
  const [mrqSelection, setMrqSelection] = React.useState({
    selectedMrq: "",
    revisions: [],
    selectedRevision: "",
  });

  const [openAddPoModal, setOpenAddPoModal] = React.useState(false);

  React.useEffect(() => {
    const fetchMrqList = async () => {
      await getMrqs({ projectId: project.id }).then((res) => setMrqList(res));
    };

    fetchMrqList();
  }, []);

  React.useEffect(() => {
    const revisions = mrqData?.revs ? mrqData.revs : [];

    setMrqSelection({
      selectedMrq: mrqData?.id,
      revisions,
      selectedRevision: mrqData?.id,
    });
  }, [mrqData?.id]);

  React.useEffect(() => {
    // console.log({ mrqSelection });
    const fetchMrqThenBidData = async () => {
      if (mrqSelection.selectedMrq) {
        const mrq = await getMrqData(
          mrqSelection.selectedRevision || mrqSelection.selectedMrq
        );

        setSelectedMrqData(mrq);
      }
    };

    fetchMrqThenBidData();
  }, [mrqSelection.selectedRevision, mrqSelection.selectedMrq]);

  return (
    <MrqContext.Provider
      value={{
        project,

        mrqList,
        setMrqList,
        mrqSelection,
        setMrqSelection,
        mrqData,

        openAddPoModal,
        setOpenAddPoModal,
      }}
    >
      {children}
    </MrqContext.Provider>
  );
}
export { MrqContextProvider, MrqContext };
